import React from "react";
import { motion } from "framer-motion";

export default function UnderConstruction() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-black text-white">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center p-8 rounded-2xl shadow-2xl bg-white/5 backdrop-blur-lg"
      >
        <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight">
          🚧 Under Construction 🚧
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mb-6">
          My personal portfolio is currently being built.
        </p>
        <p className="text-sm text-gray-400">Check back soon!</p>

        <motion.div
          className="mt-8"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
        >
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full mx-auto"></div>
        </motion.div>
      </motion.div>
    </div>
  );
}
